import { Controller } from "stimulus";
import ModalOverlay from './../components/modal-overlay';
import Body from './../components/body';

const CLASS_MENU_ACTIVE = 'is-mobile-menu-active';
const CLASS_DROPDOWN_ACTIVE = 'is-dropdown-active';

export default class extends Controller {
    opened = false;
    dropdownOpened = false;

    static targets = [
        'dropdown',
    ];

    initialize() {
        this.close = this.close.bind(this);
    }

    connect() {
        this.modalOverlay = new ModalOverlay({
            onClick: this.close
        });
        this.body = new Body();
    }

    open() {
        if(this.opened) return;
        this.opened = true;
        this.modalOverlay.activate();
        this.element.classList.add(CLASS_MENU_ACTIVE);
        this.body.disableScroll();
    }

    close() {
        if(!this.opened) return;
        this.opened = false;
        this.modalOverlay.deactivate();
        this.element.classList.remove(CLASS_MENU_ACTIVE);
        this.body.enableScroll();
    }

    toggleDropdown() {
        if(this.dropdownOpened) {
            this.dropdownOpened = false;
            this.dropdownTarget.classList.remove(CLASS_DROPDOWN_ACTIVE);
        } else {
            this.dropdownOpened = true;
            this.dropdownTarget.classList.add(CLASS_DROPDOWN_ACTIVE);
        }
    }
}


// WEBPACK FOOTER //
// ./public/assets/scripts/controllers/mobile-nav_controller.js